<template>
  <div>
    <b-overlay :show="loading" rounded="sm">
      <template #overlay>
        <OverlayButton clase="overlay-md"> </OverlayButton>
      </template>
      <b-tabs v-model="tabIndex" class="tabs-section-form-ipt">
        <div class="card-form-section mt-5">
          <b-alert show variant="warning" class="alert-warning-form-ipt">
            <div class="d-flex align-items-center">
              <div class="mr-3">
                <img
                  src="@/assets/images/icons/warning-blue.svg"
                  alt=""
                  width="28px"
                  height="28px"
                />
              </div>
              <p
                style="
                  font-size: 16px;
                  color: #263238;
                  margin-bottom: 0;
                  font-weight: 400;
                "
              >
                Selecciona <strong>Si</strong> o <strong>NO</strong> para
                responder la siguientes preguntas, de ser posible ten en cuenta
                la verificación de documentos.
              </p>
            </div>
          </b-alert>
          <hr class="hr-form-ipt" />
          <b-tab v-for="question in questions" :key="question.category_id">
            <template #title>
              <div class="d-flex align-items-center">
                {{ question?.category }}
                <b-spinner
                  type="grow"
                  small
                  variant="danger"
                  class="ml-2"
                  v-if="validateAnswer(question.answers) && !isDetail"
                />
                <span class="ml-2" v-else>&nbsp;</span>
              </div>
            </template>
            <FormSection
              :questions="question?.questions"
              :subQuetions="question?.subQuetions"
              :answers="question?.answers"
              :categoryId="question?.category_id"
              :categoryName="question?.category"
              :isBusy="isBusy"
              :isDetail="isDetail"
              @answerQuestion="answerQuestion"
              @previous="previous"
              @next="next"
            />
          </b-tab>
          <template v-if="isDisabled && !loading">
            <hr class="hr-form-ipt" />
            <b-row class="mt-5">
              <b-col cols="12" class="mb-5">
                <Textarea
                  label="Observaciones adicionales"
                  name="observation"
                  :rows="'3'"
                  :disabled="isBusy || isDetail"
                  :value="formData.observation"
                  @input="
                    (event) => (formData.observation = event.target.value)
                  "
                />
              </b-col>
              <b-col cols="12" class="mb-4 d-flex">
                <UploadFileIPT
                  @uploadFileIPT="uploadFileIPT"
                  :work_analysis_file="formData.work_analysis_file"
                  :isBusy="isBusy"
                  :isDetail="isDetail"
                  :dowlandLink="dowlandLink"
                />
              </b-col>
            </b-row>
            <hr class="hr-form-ipt" />
            <b-row
              class="mt-5"
              v-if="(!isDetail && !isSave) || !isQuestionsFirst"
            >
              <b-col cols="12">
                <b-alert show variant="danger" class="alert-danger-form-ipt">
                  <div class="d-flex align-items-center">
                    <div class="mr-3">
                      <img
                        src="@/assets/images/icons/icon-danger.svg"
                        alt=""
                        width="28px"
                        height="28px"
                      />
                    </div>
                    <p
                      style="
                        font-size: 16px;
                        color: #ac0000;
                        margin-bottom: 0;
                        font-weight: 400;
                      "
                    >
                      Para guardar la IPT es necesario llenar todos los campos.
                    </p>
                  </div>
                </b-alert>
              </b-col>
            </b-row>
          </template>
          <div class="mt-5 d-flex justify-content-between">
            <button
              class="button_primary"
              :disabled="tabIndex <= 0 || isBusy"
              @click.prevent="previous"
            >
              Anterior
            </button>
            <button
              class="button_primary"
              @click.prevent="saveQuestion"
              :disabled="isBusy"
              v-if="!isDetail && isSave && isDisabled && isQuestionsFirst"
            >
              Guardar
              <b-spinner v-if="isBusy" />
            </button>
            <button
              class="button_primary"
              @click.prevent="next"
              v-else
              :disabled="isDisabled"
            >
              Siguiente
            </button>
          </div>
        </div>
      </b-tabs>
    </b-overlay>
  </div>
</template>

<script>
import {
  getQuestionsIpt,
  getAnswersIpt,
} from "@/services/health-tracker/ges/service";
import FormSection from "./FormSection.vue";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";
import UploadFileIPT from "./UploadFileIPT.vue";
import useInputs from "@/components/general/Inputs";

const { Textarea } = useInputs();
export default {
  props: {
    isQuestionsFirst: {
      type: Boolean,
      default: false,
    },
    isBusy: {
      type: Boolean,
      default: false,
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const me = this;
    return {
      loading: false,
      questions: [],
      questions2: [],
      tabIndex: 0,
      count: 1,
      formData: {
        observation: "",
        work_analysis_file: null,
      },
      id: me.$route.params.id,
      gesId: me.$route.params.ges_id,
      answerResults: null,
      dowlandLink: null,
    };
  },
  components: {
    FormSection,
    OverlayButton,
    UploadFileIPT,
    Textarea,
  },
  computed: {
    isDisabled() {
      const me = this;
      return me.tabIndex === me.questions.length - 1 ? true : false;
    },
    isSave() {
      const me = this;
      return me.answers.every((x) => x.isStatus && x.answers != null);
    },
    answers() {
      const me = this;
      let answers = [];
      me.questions.forEach((x) => {
        x.answers.forEach((y) => {
          if (y.isStatus) answers.push(y);
        });
      });
      return answers;
    },
  },
  methods: {
    validateAnswer(answers) {
      let isValid = true;
      isValid = answers.some((x) => x.isStatus && x.answers == null);
      return isValid;
    },
    async loadQuestions() {
      const me = this;
      const questions = [];
      me.questions = [];
      me.questions2 = [];
      me.loading = true;
      me.count = 1;
      try {
        const { data } = await getQuestionsIpt(me.gesId);
        data?.forEach((x) => {
          const record = questions.find(
            (y) => y?.category_id === x?.category_id
          );
          if (record) {
            record.questions.push({
              id: x?.id,
              question: x?.question,
              subcategory: x?.subcategory?.name,
              subcategory_id: x?.subcategory_id,
              question_dependencies: x?.question_dependencies,
              number: me.count++,
              is_answer: x?.is_affirmative,
              isStatus: true,
            });
            record.answers.push({
              question_id: x?.id,
              answers: null,
              isStatus: true,
            });
          } else {
            questions.push({
              category_id: x?.category_id,
              category: x?.category?.name,
              subQuetions: [],
              questions: [
                {
                  id: x?.id,
                  question: x?.question,
                  subcategory: x?.subcategory?.name,
                  subcategory_id: x?.subcategory_id,
                  question_dependencies: x?.question_dependencies,
                  number: me.count++,
                  is_answer: x?.is_affirmative,
                  isStatus: true,
                },
              ],
              answers: [
                {
                  question_id: x?.id,
                  answers: null,
                  isStatus: true,
                },
              ],
            });
          }
        });
        questions.forEach((x) => {
          x.questions.forEach((y) => {
            if (y.subcategory_id) {
              const record = x.subQuetions.find(
                (z) => z.subcategory_id === y.subcategory_id
              );

              if (record) {
                record.questions.push({
                  id: y?.id,
                  question: y?.question,
                  number: y?.number,
                  question_dependencies: y?.question_dependencies,
                  is_answer: y.is_answer,
                  isStatus: true,
                });
              } else {
                x.subQuetions.push({
                  subcategory_id: y.subcategory_id,
                  subcategory: y.subcategory,
                  questions: [
                    {
                      id: y?.id,
                      question: y?.question,
                      number: y?.number,
                      question_dependencies: y?.question_dependencies,
                      is_answer: y.is_answer,
                      isStatus: true,
                    },
                  ],
                });
              }
            }
          });
        });

        if (me.isDetail) {
          me.questions2 = questions;
        } else {
          me.questions = questions;
        }
      } catch (error) {
        console.log(error);
      } finally {
        me.loading = me.isDetail ? true : false;
      }
    },
    answerQuestion(item) {
      const me = this;
      const {
        id,
        categoryId,
        is_answer,
        question_dependencies,
        value,
        subcategory_id,
      } = item;
      if (is_answer !== undefined) {
        const questionsByCategory = me.questions.find(
          (x) => x?.category_id === categoryId
        );
        if (questionsByCategory) {
          let changeStatus = true;
          if (is_answer) {
            changeStatus = value === "0" ? false : true;
          } else if (!is_answer) {
            changeStatus = value === "1" ? false : true;
          }

          if (questionsByCategory?.subQuetions?.length > 0) {
            const record = questionsByCategory?.subQuetions?.find(
              (x) => x?.subcategory_id === subcategory_id
            );
            if (record) {
              record?.questions?.forEach((x) => {
                if (question_dependencies?.includes(x?.id)) {
                  x.isStatus = changeStatus;
                }
              });
            }
          } else {
            questionsByCategory?.questions?.forEach((x) => {
              if (question_dependencies?.includes(x?.id)) {
                x.isStatus = changeStatus;
              }
            });
          }

          questionsByCategory?.answers?.forEach((x) => {
            if (question_dependencies?.includes(x?.question_id)) {
              x.isStatus = changeStatus;
            }
          });
        }
      }
      me.questions.forEach((x) => {
        if (x.category_id === categoryId) {
          x.answers.forEach((y) => {
            if (y.question_id === id) {
              y.answers = value;
            }
          });
        }
      });
    },
    previous() {
      const me = this;
      me.tabIndex = me.tabIndex - 1;
    },
    next() {
      const me = this;
      me.tabIndex = me.tabIndex + 1;
    },
    saveQuestion() {
      const me = this;
      me.$emit("saveQuestion", {
        answers: me.answers,
        ...me.formData,
      });
    },
    uploadFileIPT(file) {
      const me = this;
      me.formData.work_analysis_file = file;
    },
    async getAnswersIpt() {
      const me = this;
      const answersResult = [];
      me.answerResults = null;
      me.loading = true;
      try {
        const { data } = await getAnswersIpt(me.id);
        me.formData.observation = data.observation;
        me.answerResults = data;
        me.dowlandLink = data.work_analysis_file;
        me.$emit("getAnswersIpt", me.answerResults);
        data?.questions?.forEach((x) => {
          answersResult.push({
            question_id: x?.answer?.question_id,
            answer: x?.answer?.answer,
          });
        });
        me.answers.forEach((x) => {
          answersResult.forEach((y) => {
            if (x.question_id === y.question_id) {
              x.answers = y.answer;
            }
          });
        });
        me.questions2.forEach((x) => {
          if (x.questions.length > 0) {
            x.questions.forEach((y) => {
              const record = answersResult.find((z) => z.question_id === y.id);

              y.answer = record?.answer === 1 ? "1" : "0";
              y.isStatus = record ? true : false;
            });
          }
          if (x.subQuetions.length > 0) {
            x.subQuetions.forEach((y) => {
              y.questions.forEach((z) => {
                const record = answersResult.find(
                  (s) => s.question_id === z.id
                );

                z.answer = record?.answer === 1 ? "1" : "0";
                z.isStatus = record ? true : false;
              });
            });
          }
        });
        me.questions = me.questions2;
      } catch (error) {
        console.log(error);
      } finally {
        me.loading = false;
      }
    },
  },
  async mounted() {
    const me = this;
    await me.loadQuestions();
    if (me.isDetail) me.getAnswersIpt();
  },
};
</script>

<style lang="scss">
.tabs-section-form-ipt div:first-child {
  text-align: center;
}
.tabs-section-form-ipt .nav-tabs {
  background: white !important;
  padding: 4px !important;
  border-radius: 30px !important;
  align-items: center !important;
  border: 1px solid #c9caff !important;
  display: inline-flex !important;
  // width: 100% !important;
}

.tabs-section-form-ipt .nav-tabs li {
  width: 100% !important;
}

.tabs-section-form-ipt .nav-tabs .nav-item a {
  color: #546e7a !important;
  font-weight: 700 !important;
  margin-bottom: 0 !important;
}

.tabs-section-form-ipt .nav-tabs .nav-item a {
  border: none !important;
}

.tabs-section-form-ipt .nav-tabs .nav-item a.active {
  background-color: #5d5fef !important;
  color: white !important;
  padding: 8px 16px 8px 16px !important;
  border-radius: 30px !important;
  border-bottom: 0 !important;
}

.button_primary {
  display: flex;
  align-items: center;
  background-color: #5d5fef;
  height: 40px;
  border-radius: 8px;
  font-size: 18px;
  gap: 10px;
  border: none;
  color: white;
  padding: 15px;
}

.alert-danger-form-ipt {
  border: 1px solid #ac0000 !important;
  border-radius: 4px !important;
  background-color: #ffdfdf !important;
  margin-bottom: 40px;
}
</style>
